module.exports = __webpack_public_path__ + "img/h1.e1c7abcc.png";